'use client'

import { Image } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/shared/event-tracker'
import { getFingerprint } from '@marketplace-web/domain/audit'
import {
  ElectronicsLandingPageEvent,
  ElectronicsDiscoverSectionCardModel,
  landingPageEvent,
} from '@marketplace-web/domain/marketing-landing-page-data'
import { ClickableElement } from 'constants/tracking/clickable-elements'

import useElectronicsLpVersion from '../../hooks/useElectronicsLpVersion'

const DiscoverSectionCard = ({ imageUrl, title, linkUrl }: ElectronicsDiscoverSectionCardModel) => {
  const { track } = useTracking()
  const lpVersion = useElectronicsLpVersion()

  const handleOnLinkClick = async () =>
    track(
      landingPageEvent({
        event:
          lpVersion === 'buy'
            ? ElectronicsLandingPageEvent.BuyDiscoverSubcategoryLinkClick
            : ElectronicsLandingPageEvent.SellDiscoverSubcategoryLinkClick,
        target: ClickableElement.ContentCard,
        targetDetails: linkUrl,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <a
      href={linkUrl}
      className="electronics__discover-card"
      data-testid="electronics-discover-card"
      onClick={handleOnLinkClick}
    >
      <div className="electronics__discover-card-image">
        <Image src={imageUrl} scaling={Image.Scaling.Cover} loading="lazy" />
      </div>
      <p className="electronics__discover-card-title">{title}</p>
    </a>
  )
}

export default DiscoverSectionCard
